<template>
    <div class="container">
        <div class="connetheader">
            <div class="headerbg">
                <img src="../../assets/images/topbannerImg5.png" style='width:100%'/>
            </div>
        </div>
        <div class="connetbody">
            <div class="bodytip">
                <div class="tipaddress">
                    <div class="title">
                        <span>{{$t('bodys.infotitle[0]')}}</span>
                    </div>
                    <div class="content">
                        <span>武汉市东湖新技术开发区华师园北路18号光谷科技港</span>
                    </div>
                    <div class="footer">
                        <el-button type="info">Address</el-button>
                    </div>
                </div>
                <div class="tipphone">
                    <div class="title">
                        <span>联系方式</span>
                    </div>
                    <div class="content">
                        <span>027-63494808</span>
                    </div>
                    <div class="footer">
                        <el-button type="success">Address</el-button>
                    </div>
                </div>
                <div class="tipbackground">
                    <div class="title">
                        <span>公交地铁</span>
                    </div>
                    <div class="content">
                        <span>公交：789至武大园路武大园1路</span>
                        <br/>
                        <span>地铁：2号线-秀湖</span>
                    </div>
                    <div class="footer">
                        <el-button type="primary">Address</el-button>
                    </div>
                </div>
            </div>
            <div class="bodymap">
                <div class="mapmain">
                    <el-amap
                        vid="amapDemo"
                        :center="center"
                        :zoom="zoom"
                        :plugin="plugin"
                        class="amap-demo"
                        :events="events"
                        
                        >
                        <el-amap-marker 
                            :label="label" 
                            :posinset="center" 
                            vid="marker"
                            :icon="require('../../assets/images/tag.png')" 
                        />
                        <el-amap-circle
                            vid="circle" 
                            :center="center" 
                            :radius="radius"
                            fill-opacity="0.2"
                            strokeColor="#38f"
                            strokeOpacity="0.8"
                            strokeWeight="1"
                            fillColor="#38f"
                        />
                    </el-amap>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    let self = this;
    return {
        radius:100,
        label:{content:'<div class="tiptitle"><p>芸希信息科技有限公司</p></div>'+
        '<div class="tipcontent"><p>武汉市东湖新技术开发区华师园北路<br/>18号光谷科技港</p></div>'},
      zoom: 12,
      center: [114.399665,30.456781],
      plugin: [{
        pName: 'Geolocation',
        extensions:'all',
        buttonPosition: 'RB',
        events: {
          init(o) {
            // o 是高德地图定位插件实例
            o.getCurrentPosition((status, result) => {
              if (result && result.position) {
                self.lng = result.position.lng;
                self.lat = result.position.lat;
                self.center = [self.lng, self.lat];
                self.loaded = true;
                self.$nextTick();
              }
            });
          }
        }
      }],

      events: {
        click(e) {
          let {lng, lat} = e.lnglat;
          self.lng = lng;
          self.lat = lat;

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all"
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        }
      },
      lng: '',
      lat: '',
    }
  }

}
</script>

<style scoped>
    .container{
        background-color: rgb(246, 246, 246);
    }
    .connetbody {
        width: 100%;
        height: auto;
    }
    .connetbody .bodytip{
        width: 100%;
        height: 500px;
    }
    .connetbody .bodytip{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .connetbody .bodytip .baseinfomain{
        width: 1200px;
        background-color: chartreuse;
        height: 400px;
    }
    .connetbody .bodytip .tipaddress{
        width: 200px;
        height: 360px;
        background: url('../../assets/images/abthingo7.gif') top center no-repeat;
        margin-left: 80px;
        margin-right:80px ;
        position: relative;
        text-align: center;
        transition: all 0.7s;
    }
    .connetbody .bodytip .tipphone{
        width: 200px;
        height: 360px;
        background: url('../../assets/images/abthingo6.gif') top center no-repeat;
        margin-left: 80px;
        margin-right:80px ;
        position: relative;
        text-align: center;
        transition: all 0.7s;
    }
    .connetbody .bodytip .tipbackground{
        width: 200px;
        height: 360px;
        background: url('../../assets/images/abthingo5.gif') top center no-repeat;
        margin-left: 80px;
        margin-right:80px ;
        position: relative;
        text-align: center;
        transition: all 0.7s;
        transform: scale(1,1);
    }
    .connetbody .bodytip .tipaddress:hover{
        transform: scale(1.05,1.05);
    }
    .connetbody .bodytip .tipphone:hover{
        transform: scale(1.05,1.05);
    }
    .connetbody .bodytip .tipbackground:hover{
        transform: scale(1.05,1.05);
    }
    .connetbody .bodytip .title{
        position: relative;
        top: 130px;
    }
    .connetbody .bodytip .title span{
        font-size: 17px;
        color: rgb(105,83,83);
    }
    .connetbody .bodytip .content{
        position: relative;
        top: 115px;
        height: 80px;
        padding: 0 5px;
    }
    .connetbody .bodytip .content span{
        font-size: 14px;
        color: rgb(0,0,0);
    }
    .connetbody .bodytip .footer{
        position: relative;
        top: 130px;
    }
    .connetbody .bodymap{
        width: 100%;
        height: 650px;
    }
    .connetbody .bodymap .mapmain{
        width: 900px;
        height: 650px;
        margin: 0 auto;
        
    }
    
    

</style>

<style>
    .mapmain .amap-marker-label{
        width: 200px;
        height: 80px;
        border: none !important;
        top: -90px !important;
        left: 20px !important;
        background-color: rgba(255, 255, 255,0.8);
    }
    .mapmain .amap-marker-label .tiptitle{
        width: 100%;
        height: 10px;
        text-align: center;
    }
    .mapmain .amap-marker-label .tiptitle p{
        color: coral;
        
    }
    .mapmain .amap-marker-label .tipcontent{
        width: 100%;
        height: 50px;
        text-align: center;
    }
    .mapmain .amap-marker-label .tipcontent p{
        color: rgb(0, 0, 0);
    }
</style>

